import * as types from './types.js';
import _ from 'lodash';
//const LAG_CAC = parseInt(env.edilia.lagCAC); // Usamos el cac - 2 como referencia
const LAG_CAC = parseInt(-2); // Usamos el cac - 2 como referencia
/**
   * @param {[types.Indice]} indices
   * @param {Number | Date} fecha
   * @param {Number} mesesOffset
   * @returns {types.Indice}
  */
export const getIndiceAt = (indices, fecha = new Date(), mesesOffset = 0) => {
    fecha = new Date(typeof fecha === 'string' && !isNaN(fecha) ? parseInt(fecha) : fecha);
    let month, year;
    if (mesesOffset > 0) {
        month = fecha.getMonth() + mesesOffset > 11 ? fecha.getMonth() + mesesOffset - 12 : fecha.getMonth() + mesesOffset;
        year = fecha.getMonth() + mesesOffset > 11 ? fecha.getYear() + 1 : fecha.getYear();
    } else if (mesesOffset < 0) {
        month = fecha.getMonth() + mesesOffset >= 0 ? fecha.getMonth() + mesesOffset : fecha.getMonth() + (12 + mesesOffset);
        year = fecha.getMonth() + mesesOffset >= 0 ? fecha.getYear() : fecha.getYear() - 1;
    } else {
        month = fecha.getMonth();
        year = fecha.getYear();
    }
    if (Number.isNaN(month)) throw new Error('Invalid month');
    let res = (indices.find(i => {
        const iFecha = new Date(parseInt(i.fecha));
        return iFecha.getYear() === year && iFecha.getMonth() === month;
    }));
    if (res == null) throw new Error('Indice not found at ' + fecha);
    return res;
};
/**
  * @param {[types.Indice]} indices
  * @param {number} montoNominal En centavos de peso en el momento del pago
  * @param {number | Date} fecha 
  * @param {Number} mesesOffset
  * @returns {number} En CACs
*/
export const nominal2CAC = (indices, montoNominal, fecha = new Date(), mesesOffset = 0) => {
    const indice = getIndiceAt(indices, fecha, mesesOffset);
    return montoNominal / indice.cac;
};
/**
  * @param {[types.Indice]} indices
  * @param {number} valorCACs En CACs
  * @param {number | Date} fecha 
  * @param {Number} mesesOffset
  * @returns {number} Valor en centavos
*/
export const CAC2nominal = (indices, valorCACs, fecha = new Date(), mesesOffset = 0) => {
    const cac = getIndiceAt(indices, fecha, mesesOffset);
    return valorCACs * cac;
};
// /**
//   * @param {types.InfoContrato} infoContrato
//   * @returns {Object}
// */
export const getMinutaContrato = (estado, contrato, claseContrato) => {

    //const { contrato, titularidades,  } = infoContrato;
    //const { estado } = historia[0];
    const cac = estado?.indice?.cac;
    const adelantoIncialCAC = (contrato?.adelantoInicialNominal / cac) //* 100 //estado?.adelantoInicialRestanteCAC; // 
    const refuerzoSemestral = Boolean(contrato.mesRefuerzoSemestral1 || contrato.mesRefuerzoSemestral2);
    const valorObjetoAhorroCAC = claseContrato?.valorObjetoAhorroCAC;
    const nCuotas = claseContrato.nCuotas; // puede ser 350 si no hay aguinaldo?
    const cuotaRefCAC = valorObjetoAhorroCAC / nCuotas;
    const perCuotaPosesion = refuerzoSemestral ? 1.7 : 1.6//claseContrato.perCuotaPosesion;
    const adelantoRecurrenteCAC = contrato.adelantoRecurrenteCAC;
    const perPrima = contrato.perPrimaAdjudicacion;
    // Tener en cuenta la prima al bonificar
    const perBonifAdelRec = perPrima > 0 ? 0 : claseContrato.perBonificiacionAdelantoRecurrente;
    const perBonifAdelIni = claseContrato.perBonificiacionAdelantoInicial;
    const factor = ((refuerzoSemestral) ? 1.0 : (7.0 / 6.0)) / nCuotas;
    const cuotaEsperaCAC = (valorObjetoAhorroCAC * (1 - perPrima) - ((1 + perBonifAdelIni) * adelantoIncialCAC)) * factor //estado?.cuotaEsperaMesRestanteCAC //
    const nCuotasPrima = 24; //TODO: debería estar en algún lado de la ddbb en claseContrato
    const m2Eq = claseContrato.m2Eq;
    const cadencia = 350
    const puntosAdelantoInicial = 10
    const puntosAdelantoRecurrente = perPrima > 0 ? 0 : 4
    const puntosAdelantoEsporadico = 2
    const puntosCuponPagoTiempoForma = 1
    const puntosReferido = 30
    const perCampanaPAE = estado?.campanaPAE ? estado?.campanaPAE?.porcentaje : 0
    const recoGa = parseFloat(((((cuotaEsperaCAC + adelantoRecurrenteCAC) + (adelantoRecurrenteCAC * perBonifAdelRec)) / valorObjetoAhorroCAC) * 100).toFixed(3))
    const minGa = parseFloat(((cuotaEsperaCAC / valorObjetoAhorroCAC) * 100).toFixed(3))
    return {
        //PERZONALIZACIÓN PLAN DE AHORROS
        qCuoRefPlan: 350,
        cuotaReferenciaEnEspera: {
            aportes: cuotaRefCAC * cac,
            cuotasReferencia: 1,
            ga: 1 / nCuotas,
            m2: m2Eq / nCuotas,
        },
        aporteMinimoEnEsperaCAC: {
            aportes: cuotaEsperaCAC * cac,
            cuotasReferencia: cuotaEsperaCAC / cuotaRefCAC,
            ga: cuotaEsperaCAC / valorObjetoAhorroCAC,
            m2: cuotaEsperaCAC * m2Eq / valorObjetoAhorroCAC,
        },
        aporteMinimoEnTenenciaCAC: {
            aportes: (cuotaEsperaCAC * perCuotaPosesion) * cac,//((1/ nCuotas) * (valorObjetoAhorroCAC - ((1 + perBonifAdelIni) * adelantoIncialCAC ))* perCuotaPosesion * (1 - perPrima)) *  cac,
            cuotasReferencia: (cuotaEsperaCAC * perCuotaPosesion) / cuotaRefCAC,
            ga: (cuotaEsperaCAC * perCuotaPosesion) / valorObjetoAhorroCAC,
            m2: (cuotaEsperaCAC * perCuotaPosesion) * m2Eq / valorObjetoAhorroCAC,
        },
        aguinaldoRefuerzosCAC: {
            aportes: refuerzoSemestral ? (cuotaEsperaCAC + adelantoRecurrenteCAC) * cac : 0,
            cuotasReferencia: refuerzoSemestral ? (cuotaEsperaCAC + adelantoRecurrenteCAC) / cuotaRefCAC : 0,
            ga: refuerzoSemestral ? (cuotaEsperaCAC + adelantoRecurrenteCAC) / valorObjetoAhorroCAC : 0,
            m2: refuerzoSemestral ? (cuotaEsperaCAC + adelantoRecurrenteCAC) * m2Eq / valorObjetoAhorroCAC : 0,
        },
        aporteMensualPactadoEsperaCAC: {
            aportes: (cuotaEsperaCAC + adelantoRecurrenteCAC) * cac,
            cuotasReferencia: (cuotaEsperaCAC + adelantoRecurrenteCAC) / cuotaRefCAC,
            ga: (cuotaEsperaCAC + adelantoRecurrenteCAC) / valorObjetoAhorroCAC,
            m2: (cuotaEsperaCAC + adelantoRecurrenteCAC) * m2Eq / valorObjetoAhorroCAC,
        },
        bonificacionMensualCAC: {
            aportes: adelantoRecurrenteCAC * perBonifAdelRec * cac,
            cuotasReferencia: adelantoRecurrenteCAC * perBonifAdelRec / cuotaRefCAC,
            ga: adelantoRecurrenteCAC * perBonifAdelRec / valorObjetoAhorroCAC,
            m2: adelantoRecurrenteCAC * perBonifAdelRec * m2Eq / valorObjetoAhorroCAC,
        },
        aporteMensualReconocidoCAC: {
            aportes: ((cuotaEsperaCAC + adelantoRecurrenteCAC) + (adelantoRecurrenteCAC * perBonifAdelRec)) * cac,
            cuotasReferencia: ((cuotaEsperaCAC + adelantoRecurrenteCAC) + (adelantoRecurrenteCAC * perBonifAdelRec)) / cuotaRefCAC,
            ga: ((cuotaEsperaCAC + adelantoRecurrenteCAC) + (adelantoRecurrenteCAC * perBonifAdelRec)) / valorObjetoAhorroCAC,
            m2: ((cuotaEsperaCAC + adelantoRecurrenteCAC) + (adelantoRecurrenteCAC * perBonifAdelRec)) * m2Eq / valorObjetoAhorroCAC,

            //aportes: (cuotaEsperaCAC + adelantoRecurrenteCAC * perBonifAdelRec) * cac,
            //cuotasReferencia: (cuotaEsperaCAC + adelantoRecurrenteCAC * perBonifAdelRec) / cuotaRefCAC,
            //ga: (cuotaEsperaCAC + adelantoRecurrenteCAC * perBonifAdelRec) / valorObjetoAhorroCAC,
            //m2: (cuotaEsperaCAC + adelantoRecurrenteCAC * perBonifAdelRec) * m2Eq / valorObjetoAhorroCAC,
        },
        //ADELANTO INICIAL
        adelantoInicialCAC: {
            aportes: adelantoIncialCAC * cac,
            cuotasReferencia: adelantoIncialCAC / cuotaRefCAC,
            ga: adelantoIncialCAC / valorObjetoAhorroCAC,
            m2: adelantoIncialCAC * m2Eq / valorObjetoAhorroCAC,
        },
        bonificacionInicialCAC: {
            aportes: adelantoIncialCAC * perBonifAdelIni * cac,
            cuotasReferencia: adelantoIncialCAC * perBonifAdelIni / cuotaRefCAC,
            ga: adelantoIncialCAC * perBonifAdelIni / valorObjetoAhorroCAC,
            m2: adelantoIncialCAC * perBonifAdelIni * m2Eq / valorObjetoAhorroCAC,
        },
        aporteInicialReconocidoCAC: {
            aportes: adelantoIncialCAC * (1 + perBonifAdelIni) * cac,
            cuotasReferencia: adelantoIncialCAC * (1 + perBonifAdelIni) / cuotaRefCAC,
            ga: adelantoIncialCAC * (1 + perBonifAdelIni) / valorObjetoAhorroCAC,
            m2: adelantoIncialCAC * (1 + perBonifAdelIni) * m2Eq / valorObjetoAhorroCAC,
        },
        //PRIMA DE ADJUDICACIÓN
        perBienPrimaDeAdjudicacionCAC: {
            aportes: perPrima * valorObjetoAhorroCAC * cac,
            cuotasReferencia: perPrima * valorObjetoAhorroCAC / cuotaRefCAC,
            ga: perPrima,
            m2: perPrima * m2Eq,
        },
        cuotaPrimaAdjudicacionCAC: {
            aportes: perPrima * valorObjetoAhorroCAC * cac / nCuotasPrima,
            cuotasReferencia: perPrima * valorObjetoAhorroCAC / (cuotaRefCAC * nCuotasPrima),
            ga: perPrima / nCuotasPrima,
            m2: perPrima * m2Eq / nCuotasPrima,
        },
        saldoCancelarPrimaDeAdjudicacionCAC: {
            aportes: (perPrima * valorObjetoAhorroCAC * cac / nCuotasPrima) * 24,
            cuotasReferencia: (perPrima * valorObjetoAhorroCAC / (cuotaRefCAC * nCuotasPrima)) * 24,
            ga: (perPrima / nCuotasPrima) * 24,
            m2: (perPrima * m2Eq / nCuotasPrima) * 24,
        },
        //CAPITAL LICITATORIO INICIAL (C.L.I.)
        capitalLicitatorioInicial: {
            aportes: claseContrato?.principal ? (adelantoIncialCAC * claseContrato.perDpto) * (1 + perBonifAdelIni) * cac : 0,
            cuotasReferencia: adelantoIncialCAC * (1 + perBonifAdelIni) / cuotaRefCAC,//claseContrato?.principal ?  (adelantoIncialCAC * claseContrato.perDpto) * (1 + perBonifAdelIni) / cuotaRefCAC : 0,
            ga: adelantoIncialCAC * (1 + perBonifAdelIni) / valorObjetoAhorroCAC,//claseContrato?.principal ?  (adelantoIncialCAC * claseContrato.perDpto) * (1 + perBonifAdelIni) / valorObjetoAhorroCAC : 0,
            m2: adelantoIncialCAC * (1 + perBonifAdelIni) * m2Eq / valorObjetoAhorroCAC,//claseContrato?.principal ? (adelantoIncialCAC * claseContrato.perDpto) * (1 + perBonifAdelIni) * m2Eq / valorObjetoAhorroCAC : 0,
        },
        //PUNTOS
        puntosIniciales: (adelantoIncialCAC * (1 + perBonifAdelIni) / valorObjetoAhorroCAC * puntosAdelantoInicial) / (1 / nCuotas),//0.286,
        puntosMensualesProyectados: {
            PAnoCancelada: 1.00,
            PACancelada: (parseFloat(((recoGa - minGa) * 4 / 0.286).toFixed(2))) + puntosCuponPagoTiempoForma
        },
        esquemaPuntos: {
            montoAdelantadoGa: 0.286,
            adelantoInicial: puntosAdelantoInicial,
            adelantoRecurrente: 4,
            adelantoEsporadico: puntosAdelantoEsporadico,
            cuponPagoTiempoForma: 1,
            puntosReferido: puntosReferido
        },
        aporteMensualCampanaPAE: {
            aportes: (cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) * cac,
            cuotasReferencia: (cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) / cuotaRefCAC,
            ga: (cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) / valorObjetoAhorroCAC,
            m2: (cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) / valorObjetoAhorroCAC,
        },
        bonificacionCampanaPAE: {
            aportes: (cuotaRefCAC * perCampanaPAE) * cac,
            cuotasReferencia: (cuotaRefCAC * perCampanaPAE) / cuotaRefCAC,
            ga: (cuotaRefCAC * perCampanaPAE) / valorObjetoAhorroCAC,
            m2: (cuotaRefCAC * perCampanaPAE) / valorObjetoAhorroCAC,
        },
        reconocidoCampanaPAE: {
            aportes: ((cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) + (adelantoRecurrenteCAC * perBonifAdelRec) + (cuotaRefCAC * perCampanaPAE)) * cac,
            cuotasReferencia: ((cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) + (adelantoRecurrenteCAC * perBonifAdelRec) + (cuotaRefCAC * perCampanaPAE)) / cuotaRefCAC,
            ga: ((cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) + (adelantoRecurrenteCAC * perBonifAdelRec) + (cuotaRefCAC * perCampanaPAE)) / valorObjetoAhorroCAC,
            m2: ((cuotaEsperaCAC + adelantoRecurrenteCAC - (cuotaRefCAC * perCampanaPAE)) + (adelantoRecurrenteCAC * perBonifAdelRec) + (cuotaRefCAC * perCampanaPAE)) / valorObjetoAhorroCAC,
        }
    }
};

/**
 * @typedef {Object} ConversionesCAC
 * @property {number} cac - El valor de CAC.
 * @property {number} nominal - El valor de CAC multiplicado por el índice CAC.
 * @property {number} cuotasEq - El valor de CAC dividido por la relación entre el valor del objeto de ahorro CAC y el número de cuotas.
 * @property {number} m2 - El producto del valor de CAC y m2Eq, dividido por el valor del objeto de ahorro CAC.
 * @property {number} ga - El valor de CAC dividido por el valor del objeto de ahorro CAC.
 */

/**
  * @param {number} valorCAC
  * @param {types.Indice} indice
  * @param {types.ClaseContrato} claseContrato
  * @returns {ConversionesCAC} Un objeto con las siguientes propiedades: cac, nominal, cuotasEq, m2, ga.
 */

export const getConversionesCAC = (valorCAC, indice, claseContrato) => {
    const indiceCac = indice?.cac;
    const valorObjetoAhorroCAC = claseContrato?.valorObjetoAhorroCAC;
    const nCuotas = claseContrato?.nCuotas;
    const m2Eq = claseContrato?.m2Eq;
    return {
        cac: valorCAC,
        nominal: valorCAC * indiceCac,
        cuotasEq: valorCAC / (valorObjetoAhorroCAC / nCuotas),
        m2: (valorCAC * m2Eq) / valorObjetoAhorroCAC,
        ga: valorCAC / valorObjetoAhorroCAC,
    }
};
export const getImporteNuevoMes = (nuevoMes) => {
    const estado = nuevoMes.estado
    const campanasActivas = nuevoMes.campanasActivas
    //const { estado, campanasActivas } = nuevoMes;
    const cac = parseInt(estado?.indice?.cac)
    let campanaPerCupon = campanasActivas.find(c => c.tipoCampanaId === 6)
    let cuotaEsperaMesRestante = estado?.cuotaEsperaMesRestanteCAC * cac
    let adelantoRecurrenteMesRestante = estado?.adelantoRecurrenteMesRestanteCAC * cac
    let refuerzoSemestreCuotaEsperaRestante = estado?.refuerzoSemestreCuotaEsperaRestanteCAC * cac
    let refuerzoSemestreAdelantoRecurrenteRestante = estado?.refuerzoSemestreAdelantoRecurrenteRestanteCAC * cac
    let cuotaPrimaRestante = estado?.cuotaPrimaMesRestanteCAC * cac
    let cuotaPosesionRestante = estado?.cuotaPosesionRestanteCAC * cac
    let importeSinCampanaNiAdelanto = (((cuotaEsperaMesRestante
        + refuerzoSemestreCuotaEsperaRestante
        + cuotaPrimaRestante
        + cuotaPosesionRestante
        //+ estado?.moraCAC
    )) / 100).toFixed(2)
    let mora = estado?.moraCAC * cac
    let sumaNuevoMes = (((cuotaEsperaMesRestante
        + adelantoRecurrenteMesRestante
        + refuerzoSemestreCuotaEsperaRestante
        + refuerzoSemestreAdelantoRecurrenteRestante
        + cuotaPrimaRestante
        + cuotaPosesionRestante
        //+ estado?.moraCAC
    )) / 100).toFixed(2)
    return {
        importeTotal: (sumaNuevoMes * (campanaPerCupon ? (campanaPerCupon?.parametros?.porcentaje) : (1))),
        importeSinCampanaCupon: sumaNuevoMes,
        cuotaEsperaMesRestante,
        adelantoRecurrenteMesRestante,
        refuerzoSemestreCuotaEsperaRestante,
        refuerzoSemestreAdelantoRecurrenteRestante,
        cuotaPrimaRestante,
        cuotaPosesionRestante,
        plan: campanaPerCupon ? (campanaPerCupon?.parametros?.porcentaje) : (1)
    }
};
export const getBonificaciones = (pagosContratos, claseContrato) => {
    const moneyFormat = (v) => "$" + new Intl.NumberFormat("es-ES", { style: "currency", currency: "ARS" }).format(parseFloat(v).toFixed(2)).replace("ARS", "")
    let pagosConBonificacion = pagosContratos.map(pago => {
        let bonificaciones = []
        let cac = pago.estado?.indice?.cac
        let importeReconocido = parseInt(pago?.operacion?.data?.montoNominal)
        let bonificacionesNominal = []
        let tipoBonificaciones = []
        let totalBonificaciones = 0
        pago.subHistoria?.forEach(subHistoria => {
            let bonificacionCAC = subHistoria.subOperacion?.data.bonificacionCAC
            let bonificacionNominal = (parseInt(cac) * parseFloat(bonificacionCAC))?.toFixed(2)
            let hayBonificacion = (bonificacionNominal / 100)?.toFixed(2) > 0.00 ? true : false
            let tipoBonificacion = hayBonificacion ? subHistoria.subOperacion?.tipo : ''
            if (hayBonificacion) {
                bonificaciones.push({ bonificacionNominal, tipoBonificacion })
                importeReconocido = parseFloat(bonificacionNominal) + importeReconocido
                totalBonificaciones = parseFloat(bonificacionNominal) + totalBonificaciones
                bonificacionesNominal.push(moneyFormat(bonificacionNominal / 100))
                tipoBonificaciones.push(tipoBonificacion?.replace('Pago ', '')?.replace('Adelanto ', '')?.replace('Recurrente', 'Prepactado'))
            }
        })

        //bonificacionesNominal = bonificacionesNominal?.join(' - ')
        tipoBonificaciones = tipoBonificaciones.join(' - ')
        let importeReconocidoCAC = (importeReconocido / cac)
        let total = getConversionesCAC((pago.operacion.tipo === 'Pago En Espera' ? 0 : importeReconocidoCAC), pago.estado?.indice, claseContrato)

        return ({ ...pago, bonificaciones, bonificacionTotal: { tipoBonificaciones, bonificacionesNominal, totalBonificaciones, gradoAvanceTotal: total.ga, cuotasTotal: total.cuotasEq, importeTotal: total.nominal } })
    });

    return pagosConBonificacion
};
/**
     * @param {[{
* fechaEdicion: String || Number,
* fechaAplicacionDesde: String || Number,
* fechaAplicacionHasta: String || Number,
* }]} table
* asume que los cambios estan ordenados por fechaEdicion
* @returns {[]}
*/
export const getEstadosHistoricosCDC = (table) => {
    return table
        .filter(c => (c.action === 'INSERT' || c.action === 'UPDATE'))
        .map(c => ({
            ...c,
            fechaEdicion: parseInt(c.fechaEdicion),
            fechaAplicacionDesde: c.fechaAplicacionDesde != null ? parseInt(c.fechaAplicacionDesde) : 0,
            fechaAplicacionHasta: c.fechaAplicacionHasta != null ? parseInt(c.fechaAplicacionHasta) : 253370775600000
        }))
        .sort((a, b) => a.fechaEdicion - b.fechaEdicion)
        .reduce((p, x, arr) => {
            let res = p;
            if (p.length === 0) {
                res.push(x);
            }
            else if (p[0].fechaAplicacionDesde > x.fechaAplicacionHasta) {
                res = [x, ...p];
            }
            else if (p[p.length - 1].fechaAplicacionHasta <= x.fechaAplicacionDesde) {
                res = [...p, x];
            } else {
                const initPos = p.findIndex(y => y.fechaAplicacionDesde < x.fechaAplicacionDesde && y.fechaAplicacionHasta > x.fechaAplicacionDesde);
                const endPos = p.findIndex(y => y.fechaAplicacionDesde < x.fechaAplicacionHasta && y.fechaAplicacionHasta > x.fechaAplicacionHasta);

                if (initPos !== -1) p[initPos].fechaAplicacionHasta = x.fechaAplicacionDesde;
                if (endPos !== -1) p[endPos].fechaAplicacionDesde = x.fechaAplicacionHasta;

                let prev = initPos >= 0 ? p.slice(0, initPos + 1).map(x => ({ ...x })) : [];
                if (prev.length > 0) prev[prev.length - 1].fechaAplicacionHasta = x.fechaAplicacionDesde;
                let next = endPos >= 0 ? p.slice(endPos).map(x => ({ ...x })) : [];
                if (next.length > 0) next[0].fechaAplicacionDesde = x.fechaAplicacionHasta;


                res = [...prev, x, ...next];
            }
            return res;
        }, []);
};
export const getEstadosHistoricosCDCTitularidades = (table) => {
    return table
        .filter(c => (c.action === 'INSERT' || c.action === 'UPDATE'))
        .map(c => ({
            ...c,
            fechaEdicion: parseInt(c.fechaEdicion),
            fechaAplicacionDesde: c.fechaAplicacionDesde != null ? parseInt(c.fechaAplicacionDesde) : 0,
            fechaAplicacionHasta: c.fechaAplicacionHasta != null ? parseInt(c.fechaAplicacionHasta) : 253370775600000
        }))
        .sort((a, b) => a.fechaEdicion - b.fechaEdicion)
        .reduce((p, x, arr) => {
            let res = p;
            if (p.length === 0) {
                res.push(x);
            }
            else if (p[0].fechaAplicacionDesde > x.fechaAplicacionHasta) {
                res = [x, ...p];
            }
            else if (p[p.length - 1].fechaAplicacionHasta <= x.fechaAplicacionDesde) {
                res = [...p, x];
            } else {
                const initPos = p.findIndex(y => y.fechaAplicacionHasta >= x.fechaAplicacionDesde && y.fechaAplicacionDesde <= x.fechaAplicacionDesde);
                const endPos = p.findIndex(y => y.fechaAplicacionHasta >= x.fechaAplicacionHasta && y.fechaAplicacionDesde >= x.fechaAplicacionHasta);

                if (initPos !== -1) { p[initPos].fechaAplicacionHasta = x.fechaAplicacionDesde; }
                if (endPos !== -1) p[endPos].fechaAplicacionDesde = x.fechaAplicacionHasta > p[initPos].fechaAplicacionDesde ? x.fechaAplicacionHasta : p[initPos].fechaAplicacionHasta;

                res = [...(initPos >= 0 ? p.slice(0, initPos + 1) : []), x, ...(endPos >= 0 ? x.fechaAplicacionHasta > p[initPos].fechaAplicacionDesde ? p.slice(endPos) : p.slice(endPos - 1) : [])];
            };
            return res;
        }, []);
};


